import { render, staticRenderFns } from "./LastSenvenRenvue.vue?vue&type=template&id=9848a07c"
import script from "./LastSenvenRenvue.vue?vue&type=script&lang=js"
export * from "./LastSenvenRenvue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports